export default "__VITE_ASSET__ChspF2_q__"